import type { PromptSeed } from "./chat-launcher-context"
import type { AiTurn } from "./use-ai-answer"

/**
 * The seed a "Continue in chat" hands the hosted embed (AHD-13379).
 *
 * An inline AI answer (`useAiAnswer`) runs under marketing's own `/api/chat`
 * session, and the embed iframe on chat.aheadhealth.com runs its own. The thread can't be
 * handed across: glue only continues a conversation for the holder of its
 * owner token, an HttpOnly cookie on each proxy's origin that no page script
 * can read. So a plain open landed the visitor in a blank panel, and a
 * handed-off question left the agent's reply somewhere they'd never see it.
 * Re-asking the visitor's last question in the embed opens the panel on the
 * topic they were on, and a handoff it triggers has a live subscription.
 * The price is one repeated answer. `undefined` (a plain open) before any ask.
 *
 * After an inline handoff the repeat usually hands off again, so Chatwoot gets
 * a second conversation for the visitor: `<scope>.handoff` marks that one as
 * the follow-on of an inline handoff, where `<scope>.continue` is a plain move.
 */
export function continueInChatSeed(
  turns: readonly AiTurn[],
  scope: string,
  handedOff: boolean
): PromptSeed | undefined {
  const suffix = handedOff ? "handoff" : "continue"
  for (let i = turns.length - 1; i >= 0; i--) {
    if (turns[i].role === "user")
      return { prompt: turns[i].content, promptKey: `${scope}.${suffix}` }
  }
  return undefined
}
